import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/home.vue"),
      meta: { hidden: true, title: "首页" }
    },
    {
      path: "/more-info/:id",
      name: "more-info",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/more-info.vue"),
      meta: { hidden: true, title: "动态详情" }
    },
    {
      path: "/news",
      name: "news",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/news.vue"),
      meta: { hidden: true, title: "我的消息" }
    }
  ]
});
